import moment from "moment";
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChemicalSkidFilter } from '../types/ChemicalSkid';

const currentDate = moment();
const previousMonth = currentDate.clone().subtract(1, 'month');

const firstDayOfPreviousMonth = previousMonth.clone().startOf('month');
const lastDayOfPreviousMonth = previousMonth.clone().endOf('month');

const initialState: ChemicalSkidFilter & { loading: boolean } = {
    subprojects: [],
    pipelines: [],
    services: [],
    pofs: [],
    cofs: [],
    flowrates: [],
    operating_status: [],
    locations: [],
    risks: [],
    skid_status: [],
    water_cut: [],
    manifold: [],
    chemical_availability: [],
    reservoirs: [],
    date_availability_from: firstDayOfPreviousMonth.format('YYYY-MM-DD'),
    date_availability_to: lastDayOfPreviousMonth.format('YYYY-MM-DD'),
    loading: true
}

const filterSlice = createSlice({
    name: 'filter',
    initialState,
    reducers: {
        setFilter: (state, action: PayloadAction<Partial<ChemicalSkidFilter>>) => {
            return { ...state, ...action.payload }
        },
        setFilterLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload
        }
    },
})

export const { setFilter, setFilterLoading } = filterSlice.actions
export default filterSlice.reducer